<div class="client-item">
    <div class="client-header-wrapper">
        <div class="client-header">
            <div class="client-logo">
                <app-logo-small></app-logo-small>
            </div>
            <span class="client-title">Rubiz {{platform}}</span>
        </div>
        <a class="client-guide" *ngFor="let ip of deliveryIps; let i = index" target="_blank"
            [href]="generateGuideUrl(ip, platform)">
            {{ 'ClientInstallation.guide' | translate }} {{i + 1}}
            <app-chevron-right />
        </a>
    </div>
    <div class="client-info">
        <div class="client-text">
            <div class="client-meta">
                <span class="client-meta-text">{{ 'ClientInstallation.currentVersion' | translate }}
                    {{clientInformation?.version}}</span>
                <span class="dot">•</span>
                <span class="client-meta-text">{{ 'ClientInstallation.updateDate' | translate }}
                    {{clientInformation?.uploaded_at | date: 'YYYY-MM-dd'}}</span>
            </div>
            <p class="client-description">
                {{clientInformation?.release_notes}}
            </p>
        </div>
    </div>
    <div class="client-actions">
        <div class="client-action" *ngFor="let domain of appDomain; let i = index">
            <app-button [text]="('ClientInstallation.download' | translate) + ' ' + (i + 1)"
                (btnClick)="onDownloadClick(i + 1)"></app-button>
        </div>
    </div>
</div>